module.exports = __webpack_public_path__ + "static/media/filter_24.7945ac2c.svg";